import React from 'react';
import {KEY_POINT_INCOME} from '../../../configs/income';
import {ROUNDS_WITH_RUINS_INCREASED_INCOME} from '../../../configs/game';
import {KEY_POINT_TOKENS} from '../../../constants/tokens';
import {CoinsStat} from '../../PlayerStat/stats/CoinsStat';
import {WinPointsStat} from '../../PlayerStat/stats/WinPointsStat';

const KeyPointsRules = () => {
  const mine = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right'}
    src={'/img/hexes/mine.ecae90cd.png'}
    alt={'Рудник'}
    title={'Рудник'}
  />;
  const superMine = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right'}
    src={'/img/hexes/super_mine.7a4a81f7.png'}
    alt={'Великий рудник'}
    title={'Великий рудник'}
  />;
  const ruins = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right'}
    src={'/img/hexes/ruins.65862e11.png'}
    alt={'Руины'}
    title={'Руины'}
  />;
  const superRuins = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right'}
    src={'/img/hexes/super_ruins.97515170.png'}
    alt={'Великие руины'}
    title={'Великие руины'}
  />;
  const quarter = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right-left'}
    src={'/img/hexes/quarter.f69660fa.png'}
    alt={'Базовый квартал'}
    title={'Базовый квартал'}
  />;
  const centralQuarter = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right'}
    src={'/img/icons/central quarter.7dd51bfd.png'}
    alt={'Центральный квартал'}
    title={'Центральный квартал'}
  />;
  const coins = <img
    className={'policy-description-icon policy-description-icon-margin-left'}
    src={'/img/icons/coins.png'}
    alt={'Монеты'}
    title={'Монеты'}
  />;
  const winPoints = <img
    className={'policy-description-icon policy-description-icon-margin-left'}
    src={'/img/icons/win points.png'}
    alt={'Очки'}
    title={'Очки'}
  />;

  return (
    <div className="rules-page_content">
      <h2 className="rules-page_title text-coins-dark">
        Ключевые точки
      </h2>

      <div className="rules-page_section">
        <p>
          Ключевые точки размещаются на поле изначально. В течение игры игроки их на поле <b>не добавляют, не
          перемещают, не уничтожают, не убирают</b>.
        </p>
        <p>
          Ключевые точки приносят игроку-владельцу доход {coins}{winPoints} в конце раунда.
        </p>
        <p>
          <b>Владельцем</b> считается тот игрок, чей квартал {quarter}{centralQuarter} расположен <b>смежно</b> с
          этой ключевой точкой.
        </p>
        <p>
          Точка <b>не приносит дохода, пока заблокирована</b>: на ней или смежно с ней стоит отряд противника (в том
          числе нейтральный) либо заблокированы или повреждены все смежные с ней кварталы владельца. Владелец при
          этом не меняется (подробнее — в разделе «Обзор игры»).
        </p>
        <p>
          Отряд на ничейной точке держит в своей зоне контроля все смежные с ней ячейки: пока он там стоит, другие
          игроки не могут построить рядом квартал и забрать точку.
        </p>
      </div>

      <div className="rules-page_section">
        <h2>Типы ключевых точек</h2>
        <div className={'policy-description_line policy-description_line-margin-top-paragraph-large'}>
          {mine}
          <b className={'policy-description-icon-margin-right-left'}>Рудник</b>
          — доход
          <CoinsStat
            className={'policy-description-icon-margin-left-end'}
            text={KEY_POINT_INCOME[KEY_POINT_TOKENS.MINE]}
            noShrinkOnMobile={true}
            isDarkColor={true}
          />.
        </div>
        <div
          className={'policy-description_line policy-description_line policy-description_line-margin-top-paragraph-large'}
        >
          {superMine}
          <b className={'policy-description-icon-margin-right-left'}>Великий рудник</b>
          — доход
          <CoinsStat
            className={'policy-description-icon-margin-left-end'}
            text={KEY_POINT_INCOME[KEY_POINT_TOKENS.SUPER_MINE]}
            noShrinkOnMobile={true}
            isDarkColor={true}
          />.
        </div>
        <div
          className={'policy-description_line policy-description_line policy-description_line-margin-top-paragraph-large'}
        >
          {ruins}
          <b className={'policy-description-icon-margin-right-left'}>Руины</b>
          — доход
          <WinPointsStat
            className={'policy-description-icon-margin-left-end'}
            text={KEY_POINT_INCOME[KEY_POINT_TOKENS.RUINS]}
            noShrinkOnMobile={true}
            isDarkColor={true}
          />.
        </div>
        <div
          className={'policy-description_line policy-description_line policy-description_line-margin-top-paragraph-large'}
        >
          {superRuins}
          <b className={'policy-description-icon-margin-right-left'}>Великие руины</b>
          — доход
          <WinPointsStat
            className={'policy-description-icon-margin-left-end'}
            text={KEY_POINT_INCOME[KEY_POINT_TOKENS.SUPER_RUINS]}
            noShrinkOnMobile={true}
            isDarkColor={true}
          />.
        </div>
        <p>
          <b>В последних {ROUNDS_WITH_RUINS_INCREASED_INCOME} раундах игры доход очков от <span
            className={'text-win-points-dark'}
          >руин</span> удваивается.</b>
        </p>
      </div>
    </div>
  );
};

export default KeyPointsRules;
